import React, { useEffect, useState } from 'react';
import './AccessManagement.scss';
import {
    Button,
    Dropdown,
    DropdownButton,
    Card,
    Modal,
    Form,
    Col,
    Container,
    Row,
    Alert,
} from 'react-bootstrap';
import * as actionCreator from '../../actions/';
import { useNavigate } from 'react-router';
import MainLayout from '../../layouts/MainLayout';
import { connect } from 'react-redux';
import { NoOp, WaitFor } from '../../helpers/Utils';
import Overlay from '../../components/Overlay/Overlay';
import languageManager from '../../helpers/Language';
import AppTab from '../../components/AppTab/AppTab';
import { User } from '../../api';
import InviteUserIcon from 'react-ionicons/lib/PersonAddOutline';
import Sync from 'react-ionicons/lib/Sync';
import EmailValidatedImgURL from '../../assets/img/draw-kit/character_16.png';
import UserAnalytic from '../../helpers/UserAnalytic';

export const TODO_ICO_PROPS = {
    height: '22px',
    width: '22px',
    color: 'inherit',
};

export const DFLT_ICO_PROPS = {
    height: '1.0em',
    width: '1.0em',
    color: 'inherit',
};

const UserStatus = ({ active }) => {
    const cssStatus = active ? 'bg-success' : 'bg-dark';
    const label = active ? 'Active' : 'Inactive';
    return <span className={'badge ' + cssStatus}>{label}</span>;
};

const UserTable = ({ users, entities, onUserSelected }) => {
    return (
        <table className="sam-table">
            <thead>
                <tr>
                    <th>{languageManager.T('GEN_LABEL_FULL_NAME')}</th>
                    <th>{languageManager.T('GEN_LABEL_EMAIL_ADDRESS')}</th>
                    <th>{languageManager.T('GEN_LABEL_STATUS')}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {(users || []).map((u, idx) => (
                    <tr key={idx}>
                        <td>
                            {u.firstname} {u.lastname}
                        </td>
                        <td>{u.email}</td>
                        <td>
                            <UserStatus active={u.hasActiveAccount} />
                        </td>
                        <td>
                            <Button
                                size="sm"
                                variant="primary"
                                onClick={() => onUserSelected(u)}
                            >
                                {languageManager.T('GEN_LABEL_VIEW')}
                            </Button>
                        </td>
                    </tr>
                ))}
                {(users || []).length === 0 ? (
                    <tr>
                        <td className="text-center fw-light" colSpan={4}>
                            {languageManager.T('GEN_LABEL_EMPTY')}
                        </td>
                    </tr>
                ) : null}
            </tbody>
        </table>
    );
};

const UserPendingPermissionWording = {
    ADMINtrue: 'GEN_LABEL_USER_ROLE_BUSINES_OWNER',
    ADMINfalse: 'GEN_LABEL_USER_ROLE_REGULAR',
    NONE: 'GEN_LABEL_USER_ROLE_REGULAR',
};

const UserPendingTable = ({
    invitedUsers,
    onWithdrawUserInvite,
    onResendUserInvite,
    onClickOnRefreshList = NoOp,
}) => {
    return (
        <table className="sam-table">
            <thead>
                <tr>
                    <th>{languageManager.T('GEN_LABEL_EMAIL_ADDRESS')}</th>
                    <th>{languageManager.T('GEN_LABEL_ACCESS_TYPE')}</th>
                    <th style={{ width: 120 }}>
                        {languageManager.T('GEN_LABEL_STATUS')}
                    </th>
                    <th style={{ width: 210 }}>
                        {languageManager.T('GEN_LABEL_SENT_AT')}
                    </th>
                    <th />
                    <th className="text-right" style={{ width: 168 }}>
                        <Button
                            variant="primary"
                            onClick={() => onClickOnRefreshList()}
                        >
                            <Sync {...DFLT_ICO_PROPS} />
                        </Button>
                    </th>
                </tr>
            </thead>
            <tbody>
                {invitedUsers.map(
                    (
                        {
                            id,
                            signature,
                            emailAddress,
                            defaultPermissionSet,
                            businessOwner,
                            updatedAt,
                        },
                        idx
                    ) => (
                        <tr key={idx}>
                            <td>{emailAddress}</td>
                            <td>
                                {languageManager.T(
                                    UserPendingPermissionWording[
                                        defaultPermissionSet + businessOwner
                                    ] ||
                                        UserPendingPermissionWording[
                                            defaultPermissionSet
                                        ]
                                ) || UserPendingPermissionWording['FB']}
                            </td>
                            <td>
                                <span className="badge bg-secondary">
                                    {languageManager.T('GEN_LABEL_PENDING')}
                                </span>
                            </td>
                            <td>{new Date(updatedAt).toLocaleString()}</td>
                            <td>
                                <Button
                                    size="sm"
                                    variant="link"
                                    onClick={() => onWithdrawUserInvite(id)}
                                >
                                    {languageManager.T(
                                        'SETTINGS_LABEL_BTN_CANCEL_INVITE'
                                    )}
                                </Button>
                            </td>
                            <td>
                                <Button
                                    size="sm"
                                    onClick={() => onResendUserInvite(id)}
                                >
                                    {languageManager.T(
                                        'SETTINGS_LABEL_BTN_RESEND_INVITE'
                                    )}
                                </Button>
                            </td>
                        </tr>
                    )
                )}
                {invitedUsers.length === 0 ? (
                    <tr>
                        <td className="text-center fw-light" colSpan={5}>
                            {languageManager.T('SETTINGS_LABEL_NO_PDN_IVT')}
                        </td>
                    </tr>
                ) : null}
            </tbody>
        </table>
    );
};

const validateEmail = (email) => {
    const regex = RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    return regex.test(String(email));
};

const validatePhone = (phone) => {
    return phone.length === 14 || phone.length === 0;
};

const InviteUserModal = ({ onHide, refreshPendingList = NoOp }) => {
    const [overlayStatus, setOverlayStatus] = useState(false);
    const [isVisible, setVisible] = useState(true);
    const [modalWorkflow, setModalWorkflow] = useState('initial');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [isUserTypeValid, setIsUserTypeValid] = useState(true);
    const [isFormValid, setIsFormValid] = useState(false);
    const [formState, setFormState] = useState({
        emailAddress: '',
        userType: 'regular_user',
        firstName: '',
        lastName: '',
        phone: '',
    });

    useEffect(() => {
        setIsFormValid(isEmailValid && isPhoneValid && isUserTypeValid);
    }, [isEmailValid, isPhoneValid, isUserTypeValid]);

    const setFormData = (event) => {
        const key = event.target.name;
        let value = event.target.value;

        if (key === 'emailAddress') {
            setIsEmailValid(validateEmail(value));
        }

        if (key === 'phone') {
            value = value.replace(/[^\d]/g, '');

            if (value.length > 3 && value.length <= 6) {
                value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
            } else if (value.length > 6) {
                value = `(${value.slice(0, 3)}) ${value.slice(
                    3,
                    6
                )}-${value.slice(6, 10)}`;
            }

            setIsPhoneValid(validatePhone(value));
        }

        if (key === 'userType') {
            setIsUserTypeValid(value === 'regular_user');
        }

        setFormState({
            ...formState,
            [key]: value,
        });
    };
    const handleCloseModalWithCreationStatus = (
        visibleStatus,
        creationStatus
    ) => {
        setVisible(visibleStatus);
        refreshPendingList(creationStatus);
    };
    const handleFormSubmit = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (isFormValid) {
            return requestSendInvite();
        }
    };
    const requestSendInvite = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.target.blur();
        }
        setOverlayStatus(true);
        UserAnalytic.event({
            category: 'settings_user_management',
            action: 'Invite user',
        });
        const data = {
            emailAddress: formState.emailAddress,
            firstName: formState.firstName,
            lastName: formState.lastName,
            phone: formState.phone,
            userType: formState.userType,
        };
        try {
            await User.inviteUser(data, data.userType === 'business_owner');
            setOverlayStatus(false);
            setModalWorkflow('validated');
        } catch (e) {
            setModalWorkflow('error');
            setOverlayStatus(false);
        }
    };
    let modalBody = null;
    if (modalWorkflow === 'initial') {
        modalBody = (
            <>
                <Modal.Header>
                    <Modal.Title>
                        {languageManager.T('SETTINGS_INV_MDL_TITLE')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleFormSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                {languageManager.T('GEN_LABEL_ACCESS_TYPE')}
                                <span style={{ color: 'red' }}> *</span>
                            </Form.Label>
                            <Form.Check
                                id="business_owner"
                                onChange={setFormData}
                                type="radio"
                                name="userType"
                                value="business_owner"
                                label={languageManager.T(
                                    'GEN_LABEL_USER_ROLE_BUSINES_OWNER'
                                )}
                                checked={
                                    formState.userType === 'business_owner'
                                }
                            />
                            <Form.Check
                                id="regular_user"
                                onChange={setFormData}
                                type="radio"
                                name="userType"
                                value="regular_user"
                                label={languageManager.T(
                                    'GEN_LABEL_USER_ROLE_REGULAR'
                                )}
                                checked={formState.userType === 'regular_user'}
                            />
                            <Alert
                                key={'info'}
                                variant={'info'}
                                show={!isUserTypeValid}
                                className={'mt-3 mb-3'}
                            >
                                {languageManager.T('ALERT_CONTACT_EMPLOYEE')}
                            </Alert>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="email.ci1">
                            <Form.Label className="fw-bold">
                                {languageManager.T('GEN_LABEL_EMAIL_ADDRESS')}
                                <span style={{ color: 'red' }}> *</span>
                            </Form.Label>
                            <Form.Control
                                name="emailAddress"
                                type="email"
                                placeholder="name@example.com"
                                value={formState.emailAddress}
                                onChange={setFormData}
                                required
                            />
                            <Form.Label className="fw-bold">
                                {languageManager.T('GEN_LABEL_FIRST_NAME')}
                            </Form.Label>
                            <Form.Control
                                name="firstName"
                                type="text"
                                value={formState.firstName}
                                onChange={setFormData}
                            />
                            <Form.Label className="fw-bold">
                                {languageManager.T('GEN_LABEL_LAST_NAME')}
                            </Form.Label>
                            <Form.Control
                                name="lastName"
                                type="text"
                                value={formState.lastName}
                                onChange={setFormData}
                            />
                            <Form.Label className="fw-bold">
                                {languageManager.T('GEN_LABEL_PHONE')}
                            </Form.Label>
                            <Form.Control
                                name="phone"
                                type="text"
                                value={formState.phone}
                                placeholder="(xxx) xxx-xxxx"
                                onChange={setFormData}
                            />
                        </Form.Group>
                        <p style={{ color: 'red' }}>
                            <i>* {languageManager.T('FORM_REQUIRED_FIELDS')}</i>
                        </p>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Row style={{ width: '100%' }}>
                        <Col xs={6} className="text-left">
                            <Button
                                variant="secondary"
                                onClick={() => setVisible(false)}
                            >
                                {languageManager.T('GEN_CLOSE')}
                            </Button>
                        </Col>
                        <Col xs={6} className="text-right">
                            <Button
                                variant="success"
                                disabled={!isFormValid}
                                onClick={requestSendInvite}
                            >
                                {languageManager.T('SETTINGS_INV_MDL_BTN_SEND')}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </>
        );
    } else if (modalWorkflow === 'validated') {
        modalBody = (
            <>
                <Modal.Body>
                    <Row>
                        <Col xs={12} className="text-center">
                            <h1>
                                {languageManager.T('SETTINGS_INV_MDL_INV_SENT')}
                            </h1>
                            <img
                                className="mt-4"
                                src={EmailValidatedImgURL}
                                height={256}
                            />
                            <br />
                            <Button
                                className="mt-4"
                                variant="secondary"
                                onClick={() =>
                                    handleCloseModalWithCreationStatus(false)
                                }
                            >
                                {languageManager.T('GEN_CLOSE')}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </>
        );
    } else if (modalWorkflow === 'error') {
        modalBody = (
            <>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                            <h3>
                                {languageManager.T('SETTINGS_INV_MDL_INV_OOPS')}
                            </h3>
                            <Button
                                variant="secondary"
                                onClick={() => setVisible(false)}
                            >
                                {languageManager.T('GEN_CLOSE')}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </>
        );
    }
    return (
        <Modal show={isVisible} onExited={onHide}>
            {overlayStatus ? <Overlay show /> : null}
            {modalBody}
        </Modal>
    );
};

const TransformUserObjects = (users) => {
    return users.map((u) => {
        let isActive = false;
        const entities = Array.isArray(u.entities) ? u.entities : [];
        for (const entity of entities) {
            const userPermission =
                (entity.permissions || { permission: {} }).permission || {};
            if (userPermission.login) {
                isActive = true;
                break;
            }
        }
        u.hasActiveAccount = isActive;
        return u;
    });
};

const SettingsAccessManagement = ({}) => {
    const navigateManager = useNavigate();
    const [isLoading, setLoadingStatus] = useState(true);
    const [isInit, setInitStatus] = useState(false);
    const [inviteModalStatus, setInviteModalStatus] = useState(false);
    const [entities, setEntities] = useState(null);
    const [users, setUsers] = useState(null);
    const [invitedUsers, setInvitedUsers] = useState(null);
    const handleSyncPendingInvite = async (loadingStatusManagement) => {
        if (loadingStatusManagement) setLoadingStatus(true);
        try {
            const response = await User.getInvitedUsers();
            setInvitedUsers(response.data);
        } catch (e) {}
        if (loadingStatusManagement) setLoadingStatus(false);
    };
    const handleUserInviteWithdrawal = async (inviteId) => {
        try {
            if (
                !window.confirm(
                    languageManager.T(
                        'SETTINGS_LABEL_CONFIRM_USER_INVITE_REMOVAL'
                    )
                )
            )
                return;
            setLoadingStatus(true);
            await User.deleteUserInvite(inviteId);
            handleSyncPendingInvite();
            setLoadingStatus(false);
        } catch (e) {
            console.log(e);
            setLoadingStatus(false);
            window.alert(languageManager.T('ALERT_CANNOT_CANCEL_INVITE'));
        }
    };

    const handleResendUserInvite = async (inviteId) => {
        try {
            if (
                !window.confirm(
                    languageManager.T(
                        'SETTINGS_LABEL_CONFIRM_USER_INVITE_RESEND'
                    )
                )
            )
                return;
            setLoadingStatus(true);
            UserAnalytic.event({
                category: 'settings_user_management',
                action: 'User Invite',
                label: `Resend User Invite`,
            });
            await User.resendUserInvite(inviteId);
            handleSyncPendingInvite();
            setLoadingStatus(false);
        } catch (e) {
            window.alert('ALERT_CANNOT_RESEND_INVITE');
            console.log(e);
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        if (isInit) return;
        const loadUsers = async () => {
            const promiseResult = await Promise.all([
                new Promise(async (res, rej) => {
                    try {
                        const response = await User.getUsers();
                        setUsers(TransformUserObjects(response.data.users));
                        setEntities(response.data.entities);
                        return res();
                    } catch (e) {
                        return rej(e);
                    }
                }),
                new Promise(async (res, rej) => {
                    try {
                        await handleSyncPendingInvite();
                        return res();
                    } catch (e) {
                        return rej(e);
                    }
                }),
            ]);
            setInitStatus(true);
            setLoadingStatus(false);
        };
        loadUsers();
    }, [isInit]);
    const safeInvitedUsers = invitedUsers || [];
    const safeUsers = users || [];
    const activeUsers = safeUsers.filter((u) => u.hasActiveAccount);
    const inactiveUsers = safeUsers.filter((u) => !u.hasActiveAccount);
    const handleUserSelected = (u) =>
        navigateManager(`/settings/access-management/user/${u.userId}`);
    return (
        <>
            {isLoading ? <Overlay show /> : null}
            {inviteModalStatus ? (
                <InviteUserModal
                    onHide={() => setInviteModalStatus(false)}
                    refreshPendingList={() => handleSyncPendingInvite(true)}
                />
            ) : null}
            <MainLayout
                pageTitle={languageManager.T(
                    'SETTINGS_PAGE_SETTINGS_ACCESS_MANAGEMENT'
                )}
            >
                <Container className="settings-module">
                    <Row className="mt-4">
                        <Col lg={12}>
                            <Button
                                onClick={() => navigateManager('/settings')}
                            >
                                {languageManager.T('GEN_BACK')}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col lg={6}>
                            <Button
                                variant="success"
                                //onClick={() => setInviteModalStatus(true)}
                                onClick={() =>
                                    navigateManager(
                                        '/settings/access-management/invite'
                                    )
                                }
                            >
                                <InviteUserIcon {...DFLT_ICO_PROPS} />{' '}
                                {languageManager.T(
                                    'SETTINGS_LABEL_INVITE_USER'
                                )}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col lg={12}>
                            <Card className="mb-5 shadow">
                                <Card.Body className="p-0">
                                    <AppTab>
                                        {/* <AppTab.Item label={languageManager.T('SETTINGS_LABEL_TAB_ALL')}>
                                            <UserTable
                                                users={safeUsers}
                                                entities={entities || {}}
                                                onUserSelected={handleUserSelected}
                                            />
                                        </AppTab.Item> */}
                                        <AppTab.Item
                                            label={languageManager.T(
                                                'SETTINGS_LABEL_TAB_ACTIVE'
                                            )}
                                        >
                                            <UserTable
                                                users={activeUsers}
                                                entities={entities || {}}
                                                onUserSelected={
                                                    handleUserSelected
                                                }
                                            />
                                        </AppTab.Item>
                                        <AppTab.Item
                                            label={languageManager.T(
                                                'SETTINGS_LABEL_TAB_INACTIVE'
                                            )}
                                        >
                                            <UserTable
                                                users={inactiveUsers}
                                                entities={entities || {}}
                                                onUserSelected={
                                                    handleUserSelected
                                                }
                                            />
                                        </AppTab.Item>
                                        <AppTab.Item
                                            label={languageManager.T(
                                                'SETTINGS_LABEL_TAB_PENDING_IVTS'
                                            )}
                                        >
                                            <UserPendingTable
                                                invitedUsers={safeInvitedUsers}
                                                onClickOnRefreshList={() =>
                                                    handleSyncPendingInvite()
                                                }
                                                onWithdrawUserInvite={
                                                    handleUserInviteWithdrawal
                                                }
                                                onResendUserInvite={
                                                    handleResendUserInvite
                                                }
                                            />
                                        </AppTab.Item>
                                    </AppTab>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </MainLayout>
        </>
    );
};

const mapStateToProps = (appState) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsAccessManagement);
